import React from 'react';
import { Col, Row } from 'reactstrap';
import { Button, Input, Label } from 'edozvola-frontend-lib/dist/ui';
import { PhasedConstruction } from 'app/edozvola/cases/phased-construction/model/phased-construction.model';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const PhasedConstructionForm = ({ setFieldValue, readOnly, formik }) => {
  const addNewPhase = () => {
    const updated = [...formik.values.phases, { phaseValue: '' }];

    const reIndexed = updated.map((phase, index) => ({
      ...phase,
      phaseNumber: index + 1,
    }));

    setFieldValue('phases', reIndexed);
  };

  const deletePhase = (indexToRemove: number) => {
    const updated = formik.values?.phases
      .filter((p, i) => i !== indexToRemove)
      .map((phase, index) => ({
        ...phase,
        phaseNumber: index + 1,
      }));

    setFieldValue('phases', updated);
  };

  const hasPhaseErrors = () => {
    const phasesErrors = formik.errors?.phases;
    return Array.isArray(phasesErrors) && phasesErrors.some(err => err?.phaseValue);
  };

  return (
    <div>
      {formik.values.phases?.map((phase: PhasedConstruction, index) => (
        <div className="d-flex justify-content-between flex-column gap-3" key={index}>
          <Row className={'pb-4'}>
            <Col md={6}>
              <Label labelText={`${phase.phaseNumber}. faza`} />
              <div className={'red-addon-append'}>
              <Input
                disabled={readOnly}
                value={phase.phaseValue}
                error={formik.errors?.phases?.[index]?.phaseValue || ''}
                maxLength={255}
                onChange={event => {
                  formik.setFieldValue(`phases[${index}].phaseValue`, event.target.value);
                }}
                {...(!readOnly && {
                  addonAppend: <FontAwesomeIcon icon="trash" className="clickable hand" onClick={() => deletePhase(index)} />,
                })}
              />
              </div>
            </Col>
          </Row>
        </div>
      ))}
      {!readOnly && (
        <div className="pt-3">
          <Button
            label="Dodaj fazu"
            size="lg"
            color="info"
            prependIcon={'plus'}
            disabled={!formik.values.phasedConstructionType?.[0]?.id || hasPhaseErrors()}
            onClick={addNewPhase}
          />
        </div>
      )}
    </div>
  );
};

export default PhasedConstructionForm;
